import type { TranslationMessages } from '../types';

export const common: TranslationMessages = {
  accessDenied: 'Truy cập bị từ chối',
  page: {
    loading: 'Đang tải',
  },
  navigation: {
    no_results: 'Không có kết quả',
  },
  action: {
    toggle_theme: 'Chế độ tối / sáng',
    clear_array_input: 'Xóa tất cả',
    add: 'Thêm',
    remove: 'Xóa',
    choose_language: 'Chọn ngôn ngữ',
    skip: 'Bỏ qua',
    actions: 'Hành động',
    create: 'Tạo mới',
    clear: 'Xóa',
    apply: 'Áp dụng',
    help: 'Trợ giúp',
    support: 'Hỗ trợ',
    open: 'Mở',
    previous: 'Trước',
    next: 'Tiếp',
    finish: 'Hoàn thành',
    close: 'Đóng',
    cancel: 'Hủy',
    load_more: 'Tải thêm',
    confirm: 'Xác nhận',
    edit: 'Chỉnh sửa',
    show: 'Xem',
    completed: 'Đã hoàn thành',
    available: 'Có sẵn',
    review: 'Xem lại',
    refresh: 'Làm mới',
    start: 'Bắt đầu',
    filter: 'Lọc',
    add_filter: 'Thêm bộ lọc',
    apply_filters: 'Áp dụng bộ lọc',
    clear_filters: 'Xóa bộ lọc',
    back_to_list: 'Quay lại danh sách',
    search_placeholder: 'Tìm kiếm...',
    loading: 'Đang tải...',
    error_loading: 'Lỗi tải dữ liệu',
    failed_to_load: 'Không thể tải dữ liệu. Vui lòng thử lại.',
    failed_to_save: 'Không thể lưu. Vui lòng thử lại.',
    failed_to_delete: 'Không thể xóa. Vui lòng thử lại.',
    failed_to_create: 'Không thể tạo. Vui lòng thử lại.',
    failed_to_update: 'Không thể cập nhật. Vui lòng thử lại.',
    clear_all_filters: 'Xóa tất cả bộ lọc',
    table_view: 'Xem dạng bảng',
    card_view: 'Xem dạng thẻ',
    select_category: 'Chọn danh mục',
    select_status: 'Chọn trạng thái',
    minimum_amount: 'Số tiền tối thiểu',
    saving: 'Đang lưu...',
    back: 'Quay lại',
    save: 'Lưu',
    search: 'Tìm kiếm',
    delete: 'Xóa',
    yes: 'Có',
  },
  // Direct access for pos.common.save (alias to action.save)
  save: 'Lưu',
  message: {
    clear_array_input: 'Xóa tất cả các mục?',
    forbidden: 'Bạn không có quyền truy cập trang này',
    yes: 'Có',
    no: 'Không',
    loading: 'Đang tải...',
    updated: 'Đã cập nhật',
    error: 'Lỗi',
    empty: 'Không tìm thấy người dùng',
    delete_title: 'Xóa Người dùng',
    delete_content: 'Bạn có chắc chắn muốn xóa mục này không?',
    success: 'Thành công',
  },
  notification: {
    error: 'Lỗi',
    item_doesnt_exist: 'Mục không tồn tại',
  },
  field: {
    notes: 'Ghi chú',
  },
  loadingCosts: 'Đang tải chi phí...',
  loadingCostCategories: 'Đang tải danh mục chi phí...',
  failedToLoadCosts: 'Không thể tải chi phí',
  failedToLoadCostCategories: 'Không thể tải danh mục chi phí',
  loadingCategory: 'Đang tải danh mục...',
  categoryNotFound: 'Không tìm thấy danh mục',
  backToCategories: 'Quay lại Danh mục',
  loading: 'Đang tải',
  failedToDeleteCost: 'Không thể xóa chi phí',
  confirmDeleteCost: 'Bạn có chắc chắn muốn xóa chi phí này không?',
  loadingCostEntry: 'Đang tải mục chi phí...',
};
